import type { FC } from "react"
import React from "react"

import { useRecoilValue } from "recoil"

import {
  findProjectedPanelState,
  panelGridGapState,
} from "~/containers/LegacyDesigner/state/elements/panels"

const BrochurePanel_Internal: FC<{ id: string }> = ({ id }) => {
  const fg = `#0008`
  const bg = `#ddd8`
  const panel = useRecoilValue(findProjectedPanelState(id))
  const gridGap = useRecoilValue(panelGridGapState)

  return (
    <>
      <rect
        style={{ transformBox: `fill-box` }}
        transform={`rotate(${panel.r})`}
        x={panel.x}
        y={panel.y}
        width={panel.w}
        height={panel.h}
        r={6}
        fill={bg}
        stroke={undefined}
        strokeWidth={2}
      />
      <rect
        style={{ transformBox: `fill-box` }}
        transform={`rotate(${panel.r})`}
        x={
          panel.x +
          (gridGap * Math.sqrt(2) * Math.cos(((panel.r + 45) * Math.PI) / 180)) /
            2
        }
        y={
          panel.y +
          (gridGap * Math.sqrt(2) * Math.sin(((panel.r + 45) * Math.PI) / 180)) /
            2
        }
        width={panel.w - gridGap}
        height={panel.h - gridGap}
        r={6}
        fill={fg}
      />
    </>
  )
}

export const BrochurePanel = React.memo(BrochurePanel_Internal)
